/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IConversationResponse } from './IConversationResponse';
import {
    IConversationResponseFromJSON,
    IConversationResponseFromJSONTyped,
    IConversationResponseToJSON,
    IConversationResponseToJSONTyped,
} from './IConversationResponse';

/**
 * 
 * @export
 * @interface GetDmConversationsResponse
 */
export interface GetDmConversationsResponse {
    /**
     * 
     * @type {Array<IConversationResponse>}
     * @memberof GetDmConversationsResponse
     */
    conversations: Array<IConversationResponse>;
    /**
     * 
     * @type {number}
     * @memberof GetDmConversationsResponse
     */
    unreadTotal: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetDmConversationsResponse
     */
    hasMore?: boolean;
}

/**
 * Check if a given object implements the GetDmConversationsResponse interface.
 */
export function instanceOfGetDmConversationsResponse(value: object): value is GetDmConversationsResponse {
    if (!('conversations' in value) || value['conversations'] === undefined) return false;
    if (!('unreadTotal' in value) || value['unreadTotal'] === undefined) return false;
    return true;
}

export function GetDmConversationsResponseFromJSON(json: any): GetDmConversationsResponse {
    return GetDmConversationsResponseFromJSONTyped(json, false);
}

export function GetDmConversationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDmConversationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'conversations': ((json['conversations'] as Array<any>).map(IConversationResponseFromJSON)),
        'unreadTotal': json['unreadTotal'],
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
    };
}

export function GetDmConversationsResponseToJSON(json: any): GetDmConversationsResponse {
    return GetDmConversationsResponseToJSONTyped(json, false);
}

export function GetDmConversationsResponseToJSONTyped(value?: GetDmConversationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conversations': ((value['conversations'] as Array<any>).map(IConversationResponseToJSON)),
        'unreadTotal': value['unreadTotal'],
        'hasMore': value['hasMore'],
    };
}

